import { CheckCircle, Copy, Check, Info } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
import Header from '../components/Header';
import { useState } from 'react';

export default function OnboardingSuccess() {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [copiedUrl, setCopiedUrl] = useState(false);
    const [copiedId, setCopiedId] = useState(false);
    const formUrl = id ? `${window.location.origin}/form/${id}` : '';

    const handleCopyUrl = async () => {
        if (formUrl) {
            try {
                await navigator.clipboard.writeText(formUrl);
                setCopiedUrl(true);
                setTimeout(() => setCopiedUrl(false), 2000);
            } catch (err) {
                console.error('Failed to copy:', err);
            }
        }
    };

    const handleCopyId = async () => {
        if (id) {
            try {
                await navigator.clipboard.writeText(id);
                setCopiedId(true);
                setTimeout(() => setCopiedId(false), 2000);
            } catch (err) {
                console.error('Failed to copy:', err);
            }
        }
    };

    return (
        <div className="h-full flex flex-col bg-gray-50">
            <Header />

            {/* Main Content */}
            <main className="min-h-0 flex flex-col flex-grow items-center overflow-y-auto py-10">
                <div className="container w-full bg-white rounded-xl shadow-sm p-8">
                    <div className="mb-8">
                        <div className="flex justify-center mb-4">
                            <CheckCircle className="w-16 h-16 text-green-500" />
                        </div>
                        <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center">
                            Progress Saved
                        </h1>
                        <p className="text-gray-600 text-center">
                            Your progress has been successfully saved. Please save your form ID and link to continue later.
                        </p>
                    </div>
                    {id && (
                        <>
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                                    Form ID <span className="text-red-500">*</span> (Please save this)
                                </label>
                                <div className="flex items-center gap-2">
                                    <input
                                        type="text"
                                        readOnly
                                        value={id}
                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-700 font-mono focus:outline-none"
                                    />
                                    <button
                                        onClick={handleCopyId}
                                        className="px-3 py-2 border border-gray-300 rounded-md bg-white hover:bg-gray-50 transition-colors"
                                        title="Copy ID"
                                    >
                                        {copiedId ? (
                                            <Check className="w-5 h-5 text-green-600" />
                                        ) : (
                                            <Copy className="w-5 h-5 text-gray-600" />
                                        )}
                                    </button>
                                </div>
                                {copiedId && (
                                    <p className="text-sm text-green-600 mt-2 text-left">ID copied!</p>
                                )}
                            </div>
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-2 text-left">
                                    Form Link (copy to share)
                                </label>
                                <div className="flex items-center gap-2">
                                    <input
                                        type="text"
                                        readOnly
                                        value={formUrl}
                                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-700 focus:outline-none"
                                    />
                                    <button
                                        onClick={handleCopyUrl}
                                        className="px-3 py-2 border border-gray-300 rounded-md bg-white hover:bg-gray-50 transition-colors"
                                        title="Copy link"
                                    >
                                        {copiedUrl ? (
                                            <Check className="w-5 h-5 text-green-600" />
                                        ) : (
                                            <Copy className="w-5 h-5 text-gray-600" />
                                        )}
                                    </button>
                                </div>
                                {copiedUrl && (
                                    <p className="text-sm text-green-600 mt-2 text-left">Link copied!</p>
                                )}
                            </div>
                            <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg text-left">
                                <div className="flex items-start gap-2">
                                    <Info className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                                    <div>
                                        <p className="text-sm font-medium text-gray-900 mb-1">
                                            Form Complete?
                                        </p>
                                        <p className="text-sm text-gray-700">
                                            If you believe the form has been completed in full, please send the Form ID to{' '}
                                            <a 
                                                href={`mailto:support@synswi.com?subject=Onboarding Form Review&body=Form ID: ${id || ''}`}
                                                className="text-blue-600 hover:text-blue-800 underline"
                                            >
                                                support@synswi.com
                                            </a>
                                            {' '}to start the review process.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <Button onClick={() => navigate(`/form/${id}`)}>Continue Form</Button>
                        </>
                    )}
                </div>
            </main>
        </div>
    );
}

